export default __webpack_public_path__ + "static/ReactApp-557e5f756117de519d49f447a766df78.svg";